import { httpPost } from "../../services/api";
import { BinLookupData } from "../types/binLookup";

export const sdkBinLookup = async ({
  cardData,
  flowId,
  publicApiKey,
  firstSixDigits,
  cardToken,
}: {
  publicApiKey: string;
  cardData?: Record<string, string>;
  flowId?: string;
  // temp token bin lookup
  firstSixDigits?: string;
  cardToken?: string;
}) => {
  const { data } = await httpPost<{ data: BinLookupData }>(
    "bin_lookup/",
    cardData
      ? {
          ...cardData,
          flow_id: flowId,
        }
      : { first_six_digits: firstSixDigits, card_token: cardToken },
    false,
    {
      "x-public-key": publicApiKey,
    }
  );

  return {
    firstSixDigits: data.first_six_digits,
    brand: data.brand,
    cardType: data.card_type,
    issuer: data.issuer,
    issuerCountry: data.issuer_country,
    issuerCountryCode: data.issuer_country_code,
    product: data.product,
  };
};
